// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [valAkunPPN, setValAkunPPN] = useState<any>(null)
    const [listAkunPPN, setListAkunPPN] = useState<any[]>([])

    const [valAkunPiutang, setValAkunPiutang] = useState<any>(null)
    const [listAkunPiutang, setListAkunPiutang] = useState<any[]>([])


    useEffect(() => {
        getAkun()
    }, [])

    const navigate = useNavigate();


    const getAkun = () => {
        const url = apiUrl.apiUrl + '/acc/account/list-combo'
        axios
            .get(url, {
                params: {
                    // syscabang_id: cabang,
                    // sysmenu_id: 21
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListAkunPPN(data)
                    setListAkunPiutang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }


    const handleChangeAutocompleteAkunPPN = (event: SyntheticEvent, newValue: any | null) => {
        setValue('akun_ppn', newValue?.id)
        setValAkunPPN(newValue)
    }

    const handleChangeAutocompleteAkunPiutang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('akun_piutang', newValue?.id)
        setValAkunPiutang(newValue)
    }

    interface FormInputs {
        is_pkp: any,
        nama: any,
        keterangan: any,
        syscabang_id: any,
        ppn: any,
        akun_piutang: any,
        akun_ppn: any,
        diskon: any,
        is_aktif: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/customer-class/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/sales/master-customer-class')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Master Kelas Customer
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama'
                                                error={Boolean(errors.nama)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    PPN (%)
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='ppn'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='PPN (%)'
                                                type='number'
                                                error={Boolean(errors.ppn)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.ppn && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Potongan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='diskon'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Potongan'
                                                type='number'
                                                error={Boolean(errors.diskon)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.diskon && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Akun PPN
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='akun_ppn'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valAkunPPN}
                                                options={listAkunPPN}
                                                id='akun_ppn'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteAkunPPN}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Akun PPN'
                                                        error={Boolean(errors.akun_ppn)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.akun_ppn && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Akun Piutang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='akun_piutang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valAkunPiutang}
                                                options={listAkunPiutang}
                                                id='akun_piutang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteAkunPiutang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Akun Piutang'
                                                        error={Boolean(errors.akun_piutang)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.akun_piutang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            Aktif ?
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_aktif'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_aktif ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Aktif ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_aktif && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            PKP ?
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_pkp'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_pkp ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='PKP ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_pkp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
